let supportsLookbehind: boolean | undefined;

/**
 * Whether a Copilot card can be rendered in this browser.
 *
 * Ask this before triggering a card as well as before mounting one. A consumer that mounts the
 * host without checking crashes the chunk load; a consumer that triggers a card without checking
 * bills a request whose answer can never be displayed, and — because a card is dismissed by its
 * own host — leaves that card in the store with nothing on screen to clear it.
 *
 * The constraint is not CCF's own: `@1js/scc-react-markdown-renderer`, which the card view pulls
 * in, builds negative-lookbehind regexes at module-eval time. On Safari < 16.4 that throws while
 * the chunk is evaluating and takes the whole chunk down with it, so this is a load-time
 * capability gate rather than a rendering nicety. CCF uses no lookbehind of its own; the regex
 * below is only how the capability is detected.
 *
 * Feature-tested rather than UA-sniffed because `isBrowserSafari` / `isMinimumBrowserVersion`
 * are blocked at module scope by `owa-custom-rules/no-side-effects`.
 *
 * This is the single copy for CCF; the pre-CCF code has this logic duplicated in three places.
 * TODO: once `@1js/scc-react-markdown-renderer` drops the lookbehind regexes this returns true
 * unconditionally and can be deleted along with its call sites.
 * Tracked in https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/429095
 */
export function canRenderCopilotCard(): boolean {
    if (supportsLookbehind === undefined) {
        try {
            new RegExp('(?<!a)b');
            supportsLookbehind = true;
        } catch {
            supportsLookbehind = false;
        }
    }
    return supportsLookbehind;
}
